/* eslint-disable no-useless-escape */
import { CompositeDecorator } from 'draft-js';
import { DialectSpan } from 'components/decorators/dialects';

export const generateDecorator = dialects => {
	return new CompositeDecorator([
		{
			strategy: (contentBlock, callback) => {
				const _dialects = dialects.filter(dia => dia.blockKey === contentBlock.getKey());
				const _orgStr = _dialects.map(
					d =>
						'([^\uac00-\ud7a3])' +
						d.name.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&').trim() +
						'(?=[^\uac00-\ud7a3])'
				);
				if (_dialects.length > 0) {
					const regex = new RegExp(_orgStr.join('|'), 'g');
					const blockLength = contentBlock.getLength();
					let matchArr, start;
					while (
						(matchArr = regex.exec(' ' + contentBlock.getText().replace(/[\(\)]/, ' ') + ' ')) !== null
					) {
						start = matchArr.index;
						const end = Math.min(start + matchArr[0].trim().length, blockLength);
						// 앞뒤 공백을 덧댄 문자열에서 찾기 때문에 블록 범위를 벗어날 수 있다.
						if (start < end) callback(start, end);
					}
				}
			},
			component: DialectSpan,
			props: { dialects },
		},
	]);
};
